import { render, staticRenderFns } from "./optionTable.vue?vue&type=template&id=31eb2188&"
import script from "./optionTable.vue?vue&type=script&lang=js&"
export * from "./optionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports